















































import {Component, Vue} from 'vue-property-decorator';
import func from 'vue-temp/vue-editor-bridge';
import { ICodeTable, ILeaveHistoryModel } from '@/models/Common';

import API from '@/Api';
import { constants } from 'fs';

@Component
export default class LeaveHistory extends Vue {
    public leaveDate: boolean = false;
    public appliedDate: boolean = false;
    public dialog: boolean = false;
    public status: string = '';
    public regularizationTypes: ICodeTable = {} as any;
    public items: ILeaveHistoryModel [] = [];
    public leave: any = null;
    public cancel: string = 'Cancel';
    public isSelectAll: boolean = false;
    public numberArray: any = [];
    public dayId: number = 0;

    public headers: any = [
        {
          text: 'Applied Date',
          align: 'left',
          sortable: false,
          value: 'appliedDate',
        },
        {
          text: 'Leave Date',
          align: 'left',
          sortable: false,
          value: 'leaveDate',
        },
        {
          text: 'Comment',
          align: 'left',
          sortable: false,
          value: 'comment',
        },
        {
          text: 'Leave Type',
          align: 'left',
          sortable: false,
          value: 'leaveId',
        },
        {
          text: 'Approved Date',
          align: 'left',
          sortable: false,
          value: 'approvedDate',
        },
        {
          text: 'Status',
          align: 'left',
          sortable: true,
          value: 'status',
        },
        ];

    public mounted() {
      this.load();
    }
    public load() {
      API.Instance
        .get('/api/leave-history')
        .then((response) => {
            this.items = response.data;
        });
    }
     public buttonClick(item: ILeaveHistoryModel) {
        this.numberArray = [];
        this.numberArray = this.items.filter((x) => x.selected === true).map((x) => x.dayRequestId);
    }
    public deductLeave(dayId: number) {
        window.dialog.open('Confirmation', 'Are you sure do you want to Cancel the Leave?')
        .then((dialogResult: any) => {
            if (dialogResult === true) {
                API.Instance
                .post('/api/leave-history/postId?dayId=' + dayId)
                .then((res) => {
                 this.dialog = false;
                 this.load();
                });
            }
        });
    }
}
